module.exports = __webpack_public_path__ + "img/rank_diamond.320e9dee.png";